import React from 'react';

interface LoadingSpinnerIconProps {
  className?: string;
}

export const LoadingSpinnerIcon: React.FC<LoadingSpinnerIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      className={className}
    >
      <circle
        cx="40"
        cy="40"
        r="37"
        stroke="url(#spinner-gradient)"
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />
      <defs>
        <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#7DE7F1" />
          <stop offset="100%" stopColor="#012641" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LoadingSpinnerIcon;
